import { Box, CircularProgress, Stack, Typography } from '@mui/material';

export function Splash({ message = 'Loading…' }: { message?: string }) {
  return (
    <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '60vh', px: 3 }}>
      <Stack alignItems="center" spacing={2}>
        <CircularProgress size={30} />
        <Typography color="text.secondary" sx={{ fontSize: 13 }}>
          {message}
        </Typography>
      </Stack>
    </Box>
  );
}
